<template>
  <div style="padding-top:10px !important" id="pdfDom">
    <Form
      :label-width="130"
      label-position="left"
      style="margin: 30px 30px 0 30px"
      :model="formItem"
      ref="formItem"
      v-model="formItem"
      :rules="ruleValidate"
      :disabled="disabledVal"
    >
      <Row>
        <Col span="24">
          <FormItem label="应聘职位" prop="candidatePosition">
            <Input v-model="formItem.candidatePosition" />
          </FormItem>
        </Col>
      </Row>
      <p style="color: red; font-size: 12px;margin-bottom:20px">
        非常感谢您应聘我公司的职位。请您务必认真、如实地填写以下表格。希望这是我们良好合作的开始。谢谢合作!
      </p>
      <h4>个人信息：</h4>
      <Upload
        :action="action"
        ref="my-upload"
        :on-success="uploadSuccess"
        style="width:150px;margin: 20px 0;"
      >
        <Button>上传身份证信息</Button>
      </Upload>
      <div class="groupDisplay">
        <div class="elementDisplay">
          <FormItem label="中文姓名：" prop="userName">
            <Input v-model="formItem.userName" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="性别：">
            <Select v-model="formItem.gender" :clearable="true" placeholder="">
              <Option
                :value="item.code"
                v-for="(item, i) in genderList"
                :key="i"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="民族：" prop="ethnic">
            <Select v-model="formItem.ethnic" :clearable="true" placeholder="">
              <Option
                :value="item.code"
                v-for="(item, i) in nationList"
                :key="i"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="姓（拼音）：">
            <Input v-model="formItem.lastNamePinyin" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="名（拼音）：">
            <Input v-model="formItem.firstNamePinyin" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="英文名：">
            <Input v-model="formItem.userEname" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="国籍：" prop="nationality">
            <Select
              v-model="formItem.nationality"
              :clearable="true"
              placeholder=""
            >
              <Option
                :value="item.code"
                v-for="(item, i) in nationalityList"
                :key="i"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="身份证号码：" prop="nationalIdNumber">
            <Input v-model="formItem.nationalIdNumber" @on-change="idchange" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="护照号码：" prop="passportnumber">
            <Input v-model="formItem.passportnumber" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="年龄：">
            <Input v-model="formItem.age" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="婚姻状态：">
            <Input v-model="formItem.maritalStatus" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="手机：" prop="mobilePersonal">
            <Input v-model="formItem.mobilePersonal" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="个人电子邮箱：" prop="mail">
            <Input v-model="formItem.mail" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="开户银行：">
            <Input v-model="formItem.bankName" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="开户行支行：">
            <Input v-model="formItem.bankBranch" />
          </FormItem>
        </div>
        <div class="elementDisplay">
          <FormItem label="银行卡号：">
            <Input type="number" v-model="formItem.bankAccountNumber" />
          </FormItem>
        </div>
        <div class="elementDisplay"></div>
        <div class="elementDisplay"></div>
      </div>
      <Row>
        <Col span="24">
          <FormItem label="常住地址：">
            <Input v-model="formItem.homeAddress" />
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem label="户籍地址：">
            <Input v-model="formItem.legalAddress" />
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Form style="margin: 0 30px">
      <h4>教育背景</h4>
      <Table border :columns="columns1" :data="data1" disabled>
        <template
          slot-scope="{ row, index }"
          slot="action"
          :disabled="disabledVal"
        >
          <div>
            <span
              class="ivu-icon ivu-icon-ios-create"
              style="font-size: 18px; color: rgb(45, 140, 240); cursor: pointer"
              @click="editItem1(row, index)"
              :disabled="disabledVal"
            ></span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action1">
          <div>
            <Icon
              :disabled="disabledVal"
              style="font-size: 18px; color: red; cursor: pointer"
              type="ios-trash"
              @click="deleteItem1(row, index)"
            />
          </div>
        </template>
      </Table>
      <div class="NewInformation">
        <div class="NewInformation_title" @click="addItem1()">新增</div>
      </div>

      <h4>工作经验</h4>
      <Table border :columns="columns2" :data="data2">
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <span
              class="ivu-icon ivu-icon-ios-create"
              style="font-size: 18px; color: rgb(45, 140, 240); cursor: pointer"
              @click="editItem2(row, index)"
            ></span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action1">
          <div>
            <Icon
              style="font-size: 18px; color: red; cursor: pointer"
              type="ios-trash"
              @click="deleteItem2(row, index)"
            />
          </div>
        </template>
      </Table>
      <div class="NewInformation">
        <div class="NewInformation_title" @click="addItem2()">新增</div>
      </div>

      <h4>社会关系</h4>
      <Table border :columns="columns3" :data="data3">
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <span
              class="ivu-icon ivu-icon-ios-create"
              style="font-size: 18px; color: rgb(45, 140, 240)"
              @click="editItem3(row, index)"
            ></span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action1">
          <div>
            <Icon
              style="font-size: 18px; color: red; cursor: pointer"
              type="ios-trash"
              @click="deleteItem3(row, index)"
            />
          </div>
        </template>
      </Table>
      <div class="NewInformation">
        <div class="NewInformation_title" @click="addItem3()">新增</div>
      </div>

      <h4>其他重要信息</h4>
      <Form :label-width="283" label-position="left" :disabled="disabledVal">
        <div class="RowDisplay">
          <div class="ColDisplay">
            <FormItem label="离职通知期：">
              <Input v-model="formItem.resignationNoticePeriod" />
            </FormItem>
          </div>
          <div class="ColDisplay">
            <FormItem label="应聘者来源（微信，网站，朋友推荐）：">
              <Input v-model="formItem.applicationResource" />
            </FormItem>
          </div>
          <div class="ColDisplay">
            <FormItem label="是否有亲属在本公司工作：">
              <Select placeholder="" v-model="formItem.relativesWorkingCompany">
                <Option
                  :value="item.code"
                  v-for="(item, i) in workinhereList"
                  :key="i"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </div>
          <div class="ColDisplay">
            <FormItem label="内部推荐人信息：">
              <Input v-model="formItem.internalRecommenderInfo" />
            </FormItem>
          </div>
        </div>
      </Form>
      <P
        >基于您对公司业务(空调及冷链运输业务)的了解，您本人或直系亲属是否在与我司存在直接竞争关系或业务关系的公司担任法定代表人、董事、监事或股东岗位?</P
      >
      <Input
        type="textarea"
        style="width: 100%; margin-top: 10px"
        v-model="formItem.clarifyOne"
        :disabled="disabledVal"
      />

      <P style="margin-top: 18px"
        >如申请者与现用人单位或者之前的各用人单位或者任何第三方之间有在申请者与他们有关关系结束后仍然适用的协议的，
        请注明(如购房贷款，培训偿还，竞业限制，在前公司是否拥有过专利权、竞业限制协议等等):</P
      >
      <Radio-group v-model="formItem.clarifyTwo" :disabled="disabledVal">
        <Radio
          label="无此等协议"
          style="display: block; margin-top: 10px"
          :disabled="disabledVal"
        ></Radio>
        <Radio label="有此等协议，具体为：" :disabled="disabledVal"></Radio>
        <Input
          style="display: inline-block; width: 1200px"
          v-model="formItem.clarify_two_detail"
          :disabled="formItem.clarifyTwo == '无此等协议'"
        />
      </Radio-group>
      <P style="margin-top: 18px"
        >如申请者曾有刑事犯罪记录、被前雇主单方解除的记录(包括因违规问题而离职或被劝退等情形的记录)，请注明:</P
      >
      <Radio-group v-model="formItem.clarifyThree">
        <Radio
          label="无此等记录"
          style="display: block; margin-top: 10px"
          :disabled="disabledVal"
        ></Radio>
        <Radio label="有此等记录，具体为：" :disabled="disabledVal"></Radio>
        <Input
          style="display: inline-block; width: 1200px"
          v-model="formItem.clarify_three_detail"
          :disabled="formItem.clarifyThree == '无此等记录'"
        />
      </Radio-group>
    </Form>
    <br />
    <div style="margin: 0 30px">
      <h4>本人同意、授权及承诺</h4>
      <P
        >本人自愿通过本申请表以及其他途径向公司（包括其成员公司）、员工和公司所选择的代理或供应商（合称“审查主体”）
        提供信息(包括属于个人敏感信息的身份证号码以及其它个人信息)
        （“信息”）以供审核本人是否适合所申请的岗位。</P
      >
      <ul>
        <li class="liStyle">
          以合法的方式为了进行下述各项核查而处理、使用、披露、传播、存储、与其它审查主体共享和审核信息，其中部分审查主体可能位于中国境外;
        </li>
        <li class="liStyle">
          进行核查主体告知本人的为审核本人是否适合所申请的岗位而进行的各项核查、审核和/或审查(“核查”)
          ,核查包括但不限于审核教育背景、简历、聘用记录和绩效工作表现、职业资质，证书、薪资、离职原因，或进行利益冲突调查等等;
        </li>
        <li class="liStyle">
          如果核查主体为进行核查而接触的第三方要求的，可以将本人上述同意以及授权出示给该等第三方以供他们提供真实信息以及评价:
        </li>
        <li class="liStyle">
          在公司内部人才库中保留信息，并定明或不定期通过电子邮件、短信等向本人发送面试调研、职位机会和/或其它广告。
        </li>
      </ul>
      <br />
      <P>本人，在此，承诺并保证：</P>
      <ul>
        <li class="liStyle">
          本人在本申请表或通过其他途径向审查主体提供的所有信息,答复、回复、陈述、文件和材料均真实、完整、准确、有效和可靠;
        </li>
        <li class="liStyle">
          对于本人所提供的必要的第三方的个人信息，我在向审查主体披露前已经获得该等第三方必要且充分的同意;
        </li>
        <li class="liStyle">本人会完全配合审查主体进行各项核查;</li>
        <li class="liStyle">
          本人不会隐瞒任何可能对审核本人是否适合所申请的岗位而产生影响的事项(“重大事项”)。
        </li>
      </ul>
      <br />
      <p style="text-indent:2em">
        本人理解，如果有任何不实陈述。隐病重大事项或者欺骗的，可能将导致取消候选人资格如签发聘用函的可能导致聘用函的解除/终止;如果已经建立劳动关系的，
        则无任何赔偿而单方解除劳动合同。本人。在此，进一步永久地豁免审核主体，免除审核主体承担可由本人针对审核主体而提出的任何因核查引起的或与之有关的任何责任，
        包括但不限于任何潜在的主张、要求、指责、损害赔偿、行动或其他任何种类或性质的控诉(“责任”)
        。本人将确保审核主体免受第三方追究责任。
      </p>
    </div>
    <Form
      :label-width="130"
      label-position="left"
      style="margin: 30px"
      :disabled="disabledVal"
    >
      <div class="RowDisplay">
        <div class="ColDisplay">
          <FormItem label="填表人签名：">
            <Input v-model="formItem.signatureApplicant" />
          </FormItem>
        </div>
        <div class="ColDisplay">
          <FormItem label="日期:">
            <DatePicker
              type="date"
              style="width: 100%"
              format="yyyy-MM-dd"
              v-model="formItem.applicantDate"
            ></DatePicker>
          </FormItem>
        </div>
      </div>
      <h4>
        公司承诺仅在必要范围内披露您的个人信息，并遵守与个人信息保护相关的法律法规。
      </h4>
    </Form>
    <div class="btnGroup">
      <!-- <Button class="btnStyle" v-if="showBtn && !getQueryVariable('id')">保存</Button> -->
      <Button
        class="btnStyle"
        @click="submit"
        v-if="showBtn && !getQueryVariable('id')"
        >提交</Button
      >
      <Button class="btnStyle" v-on:click="getPDF()">导出PDF</Button>
      <Button
        class="btnStyle"
        @click="returnPages"
        v-if="getQueryVariable('id')"
        >返回</Button
      >
    </div>
    <!-- 第一个表格新增数据 -->
    <Modal v-model="showInformation1" width="60%">
      <p slot="header" style="text-align: left">
        <Icon type="information-circled"></Icon>
        <span>{{ titleText }}</span>
      </p>
      <div class="center" style="margin:20px 0 50px 0;">
        <Form
          :label-width="180"
          label-position="left"
          :model="messageItem1"
          ref="messageItem1"
          :rules="rules1"
          v-if="showInformation1"
        >
          <Row>
            <Col span="10" offset="1" style="margin-top:10px">
              <FormItem label="开始日期：" prop="studyingStartDate">
                <DatePicker
                  v-model="messageItem1.studyingStartDate"
                  type="date"
                  style="width: 100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="10" offset="2" style="margin-top:10px">
              <FormItem label="毕业日期:" prop="studyingEndDate">
                <DatePicker
                  v-model="messageItem1.studyingEndDate"
                  type="date"
                  style="width: 100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="10" offset="1" style="margin-top:25px">
              <FormItem label="学校名称:" prop="schoolName">
                <Input v-model="messageItem1.schoolName" />
              </FormItem>
            </Col>
            <Col span="10" offset="2" style="margin-top:25px">
              <FormItem label="专业名称：" prop="major">
                <Input v-model="messageItem1.major" />
              </FormItem>
            </Col>
            <Col span="10" offset="1" style="margin-top:20px">
              <FormItem label="学历:" prop="degree">
                <Input v-model="messageItem1.degree" />
              </FormItem>
            </Col>
            <Col span="10" offset="2" style="margin-top:20px">
              <FormItem label="最高学历:" prop="whetherHighestEducation">
                <Select
                  v-model="messageItem1.whetherHighestEducation"
                  :clearable="true"
                  placeholder=""
                >
                  <Option
                    :key="item.code"
                    :value="item.code"
                    v-for="item in whetherHighestEducationList"
                    >{{ item.label }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div
        slot="footer"
        class="footer"
        style="display: flex;justify-content: flex-end"
      >
        <Button type="primary" @click="confirmData1()">确定</Button>
      </div>
    </Modal>
    <!-- 第二个表格新增数据 -->
    <Modal v-model="showInformation2" width="60%">
      <p slot="header" style="text-align: left">
        <Icon type="information-circled"></Icon>
        <span>{{ titleText }}</span>
      </p>
      <div class="center">
        <Form
          :label-width="180"
          label-position="left"
          ref="messageItem2"
          :model="messageItem2"
          :rules="rules2"
          v-if="showInformation2"
          style="margin:15px 0;"
        >
          <Row>
            <Col span="10" offset="1">
              <FormItem label="开始日期：" prop="workingStartDate">
                <DatePicker
                  v-model="messageItem2.workingStartDate"
                  type="date"
                  style="width: 100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="10" offset="2">
              <FormItem label="结束日期：" prop="workingEndDate">
                <DatePicker
                  v-model="messageItem2.workingEndDate"
                  type="date"
                  style="width: 100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col span="10" offset="1">
              <FormItem label="前任公司：" prop="workingName">
                <Input v-model="messageItem2.workingName" />
              </FormItem>
            </Col>
            <Col span="10" offset="2">
              <FormItem label="职位：" prop="position">
                <Input v-model="messageItem2.position" />
              </FormItem>
            </Col>
            <Col span="10" offset="1">
              <FormItem label="离职原因：" prop="reasonLeave">
                <Input v-model="messageItem2.reasonLeave" />
              </FormItem>
            </Col>
            <Col span="22" offset="1">
              <FormItem label="工作描述:" prop="majorDuties">
                <Input
                  type="textarea"
                  v-model="messageItem2.majorDuties"
                  :rows="3"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div
        slot="footer"
        class="footer"
        style="display: flex;justify-content: flex-end"
      >
        <Button type="primary" @click="confirmData2()">确定</Button>
      </div>
    </Modal>
    <!-- 第三个表格新增数据 -->
    <Modal v-model="showInformation3" width="60%">
      <p slot="header" style="text-align: left">
        <Icon type="information-circled"></Icon>
        <span>{{ titleText }}</span>
      </p>
      <div class="center">
        <Form
          :label-width="180"
          label-position="left"
          ref="messageItem3"
          :model="messageItem3"
          :rules="rules3"
          v-if="showInformation3"
        >
          <Row>
            <Col span="10" offset="1">
              <FormItem label="姓名" prop="userName">
                <Input v-model="messageItem3.userName" />
              </FormItem>
            </Col>
            <Col span="10" offset="2">
              <FormItem label="关系" prop="relationship">
                <Input v-model="messageItem3.relationship" />
              </FormItem>
            </Col>
            <Col span="10" offset="1">
              <FormItem label="手机" prop="mobilePersonal">
                <Input v-model="messageItem3.mobilePersonal" />
              </FormItem>
            </Col>
            <Col span="10" offset="2">
              <FormItem label="紧急联系人" prop="emergencyContact">
                <Input v-model="messageItem3.emergencyContact" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div
        slot="footer"
        class="footer"
        style="display: flex;justify-content: flex-end"
      >
        <Button type="primary" @click="confirmData3()">确定</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    // 身份证验证
    const checkIDCard = (rule, value, callback) => {
      if (this.formItem.nationality !== "中国") {
        callback();
      }
      const IDCardReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      // const IDCardReg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/
      if (value) {
        if (IDCardReg.test(value)) {
          callback();
        } else {
          callback(new Error("身份证号格式不正确"));
        }
      } else {
        callback(new Error("请输入身份证号"));
      }
    };
    const checkPhoneNum = (rule, value, callback) => {
      const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!value) {
        callback("请填写手机号码");
      } else if (!myreg.test(value)) {
        callback("手机号码有误");
      } else {
        callback();
      }
    };
    const cheackEmail = (rule, value, callback) => {
      var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (!value) {
        callback("请填写邮箱号码");
      } else if (!myreg.test(value)) {
        callback(new Error("邮箱格式有误"));
        myreg.focus();
        return false;
      } else {
        callback();
      }
    };
    return {
      ruleValidate: {
        candidatePosition: [{ required: true, message: "请输入应聘职位" }],
        userName: [{ required: true, message: "请输入中文姓名" }],
        // gender: [{ required: true,message: '请选择性别'}],
        nationalIdNumber: [
          { required: true, message: "请输入证件号码" },
          { required: true, validator: checkIDCard }
        ],
        mail: [{ required: true, validator: cheackEmail }],
        mobilePersonal: [{ required: true, validator: checkPhoneNum }]
      },
      rules1: {
        studyingStartDate: [{ required: true, message: "请选择开始日期" }],
        studyingEndDate: [{ required: true, message: "请选择毕业日期" }],
        schoolName: [{ required: true, message: "请填写学校名称" }],
        major: [{ required: true, message: "请填写专业名称" }],
        degree: [{ required: true, message: "请填写学位" }],
        whetherHighestEducation: [{ required: true, message: "请填写最高学历" }]
      },
      rules2: {
        workingStartDate: [{ required: true, message: "请选择开始日期" }],
        workingEndDate: [{ required: true, message: "请选择结束日期" }],
        workingName: [{ required: true, message: "请填写前任公司" }],
        position: [{ required: true, message: "请填写职位" }],
        majorDuties: [{ required: true, message: "请填写工作描述" }],
        reasonLeave: [{ required: true, message: "请填写离职原因" }]
      },
      rules3: {
        userName: [{ required: true, message: "请选择姓名" }],
        relationship: [{ required: true, message: "请选择关系" }],
        mobilePersonal: [{ required: true, message: "请填写手机" }],
        emergencyContact: [{ required: true, message: "请填写紧急联系人" }]
      },
      props: ["comHistory"],
      date: new DateUtil(),
      formItem: {},
      columns1: [
        {
          title: "开始日期：",
          key: "studyingStartDate",
          align: "center",
          width: "235",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.studyingStartDate, "YYYY/MM/DD")
            );
          }
        },
        {
          title: "毕业日期",
          key: "studyingEndDate",
          align: "center",
          width: "235",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.studyingEndDate, "YYYY/MM/DD")
            );
          }
        },
        {
          title: "学校名称",
          key: "schoolName",
          align: "center",
          width: "240"
        },
        {
          title: "专业名称：",
          key: "major",
          align: "center",
          width: "240"
        },
        {
          title: "学历",
          key: "degree",
          align: "center",
          width: "220"
          // render: (h, params) => {
          //   var name1 = "";
          //   this.Degree
          //     ? this.Degree.forEach((item, index) => {
          //         if (item.code == params.row.degree) {
          //           name1 = item.name;
          //         }
          //       })
          //     : "";
          //   return h("span", name1);
          // },
        },
        {
          title: "最高学历",
          key: "whetherHighestEducation",
          align: "center",
          width: "205",
          render: (h, params) => {
            let whetherHighestEducation1 = params.row.whetherHighestEducation;
            this.whetherHighestEducationList.forEach(item => {
              if (item.code == params.row.whetherHighestEducation) {
                whetherHighestEducation1 = item.label;
              }
            });
            return h("span", whetherHighestEducation1);
          }
        },
        {
          title: "编辑",
          key: "edit",
          align: "center",
          slot: "action",
          width: "100"
        },
        {
          title: "删除",
          key: "delect",
          align: "center",
          slot: "action1",
          width: "100"
        }
      ],
      data1: [],
      columns2: [
        {
          title: "开始日期",
          key: "workingStartDate",
          align: "center",
          width: "235",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.workingStartDate, "YYYY/MM/DD")
            );
          }
        },
        {
          title: "结束日期",
          key: "workingEndDate",
          align: "center",
          width: "235",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.workingEndDate, "YYYY/MM/DD")
            );
          }
        },
        {
          title: "前任公司",
          key: "workingName",
          align: "center",
          width: "240"
        },
        {
          title: "职位",
          key: "position",
          align: "center",
          width: "200"
        },
        {
          title: "工作描述",
          key: "majorDuties",
          align: "center",
          width: "225"
        },
        {
          title: "离职原因",
          key: "reasonLeave",
          align: "center",
          width: "240"
        },
        {
          title: "编辑",
          key: "edit",
          align: "center",
          slot: "action",
          width: "100"
        },
        {
          title: "删除",
          key: "delect",
          align: "center",
          slot: "action1",
          width: "100"
        }
      ],
      data2: [],
      columns3: [
        {
          title: "姓名",
          key: "userName",
          align: "center"
        },
        {
          title: "关系",
          key: "relationship",
          align: "center"
        },
        {
          title: "手机",
          key: "mobilePersonal",
          align: "center"
        },
        {
          title: "紧急联系人",
          key: "emergencyContact",
          align: "center"
        },
        {
          title: "编辑",
          key: "edit",
          align: "center",
          slot: "action",
          width: "100"
        },
        {
          title: "删除",
          key: "delect",
          align: "center",
          slot: "action1",
          width: "100"
        }
      ],
      data3: [],
      genderList: [],
      nationalityList: [],
      workinhereList: [],
      nationList: [],
      messageItem1: {},
      messageItem2: {},
      messageItem3: {},
      type: "",
      titleText: "新增",
      showInformation1: false,
      showInformation2: false,
      showInformation3: false,
      obj1: {},
      obj2: {},
      obj3: {},
      index: "",
      repeat: 0,
      loading: false,
      showBtn: true,
      disabledVal: false,
      action: "/api/analysis/analysisIDInfo",
      whetherHighestEducationList: [
        {
          code: "0",
          label: "否"
        },
        {
          code: "1",
          label: "是"
        }
      ]
    };
  },
  created() {
    if (this.getQueryVariable("id")) {
      this.getData();
    }
    if (this.getQueryVariable("id") && this.getQueryVariable("id") !== "") {
      this.disabledVal = true;
    } else {
      this.disabledVal = false;
    }
    this.getSelectLabel();
  },
  watch: {
    "formItem.nationalIdNumber"(val) {
      if (val.length == 18) {
        let str = "",
          year,
          month,
          day,
          year1,
          year2,
          num;
        str = val;
        year = str.slice(6, 10);
        month = str.slice(10, 12);
        day = str.slice(12, 14);
        year1 = new Date().toLocaleDateString();
        year2 = year + "/" + month + "/" + day;
        num =
          Math.abs(new Date(year1).getTime() - new Date(year2).getTime()) /
          1000 /
          24 /
          60 /
          60;
        this.formItem.age = Math.floor(num / 365);
      }
    }
  },
  methods: {
    getSelectLabel() {
      axios
        .post(
          "OnboardingApplication/selectApplyOnboardingApplicationComboBox",
          {}
        )
        .then(res => {
          if (res) {
            this.nationList = res.ETHNIC;
            this.genderList = res.GENDER;
            this.nationalityList = res.PPISSUECOUNTRY;
            this.workinhereList = res.YESORNO;
          }
        });
    },
    getData() {
      let obj = {
        id: this.getQueryVariable("id")
      };
      this.loading = true;
      axios
        .post(
          "OnboardingApplication/SelectIndividualOnboardingApplication",
          obj
        )
        .then(res => {
          this.loading = false;
          if (res) {
            this.formItem = res.data[0];
            this.data1 = res.data[0].applyOnboardingEducations;
            this.data2 = res.data[0].applyOnboardingWorks;
            this.data3 = res.data[0].applyOnboardingSocials;
          }
        });
    },
    getPDF() {
      this.getPdf("入职信息");
    },
    // 获取年龄数
    idchange() {
      this.$nextTick(() => {
        if (this.formItem.nationalIdNumber.length == 18) {
          let str = "",
            year,
            month,
            day,
            year1,
            year2,
            num;
          str = this.formItem.nationalIdNumber;
          year = str.slice(6, 10);
          month = str.slice(10, 12);
          day = str.slice(12, 14);
          year1 = new Date().toLocaleDateString();
          year2 = year + "/" + month + "/" + day;
          num =
            Math.abs(new Date(year1).getTime() - new Date(year2).getTime()) /
            1000 /
            24 /
            60 /
            60;
          this.formItem.age = Math.floor(num / 365);
        }
      });
    },
    uploadSuccess(val) {
      let obj = {};
      obj = val;
      this.$set(this.formItem, "userName", obj.data.Name);
      obj.data.Sex == "男"
        ? this.$set(this.formItem, "gender", "M")
        : obj.data.Sex == "女"
        ? this.$set(this.formItem, "gender", "F")
        : "";
      this.nationList.forEach(item => {
        console.log(
          item.name,
          obj.data.Nation,
          item.name.indexOf(obj.data.Nation)
        );
        if (item.name.indexOf(obj.data.Nation) == 0) {
          this.$set(this.formItem, "ethnic", item.code);
        }
      });
      this.$set(this.formItem, "nationalIdNumber", obj.data.IdNum);
      this.$set(this.formItem, "legalAddress", obj.data.Address);
    },
    addItem1() {
      if (this.disabledVal == false) {
        this.messageItem1 = {};
        this.showInformation1 = true;
        this.type = 1;
        this.titleText = "新增";
      }
    },
    editItem1(row, index) {
      if (this.disabledVal == false) {
        this.showInformation1 = true;
        this.type = 2;
        this.index = index;
        this.titleText = "编辑";
        this.messageItem1.studyingStartDate = row.studyingStartDate;
        this.messageItem1.studyingEndDate = row.studyingEndDate;
        this.messageItem1.schoolName = row.schoolName;
        this.messageItem1.major = row.major;
        this.messageItem1.degree = row.degree;
        this.messageItem1.whetherHighestEducation = row.whetherHighestEducation;
      }
    },
    deleteItem1(row, index) {
      if (this.disabledVal == false) {
        this.data1.splice(index, 1);
      }
    },
    confirmData1() {
      this.$refs["messageItem1"].validate(valid => {
        if (valid) {
          this.obj1 = {
            studyingStartDate: this.messageItem1.studyingStartDate,
            studyingEndDate: this.messageItem1.studyingEndDate,
            schoolName: this.messageItem1.schoolName,
            major: this.messageItem1.major,
            degree: this.messageItem1.degree,
            whetherHighestEducation: this.messageItem1.whetherHighestEducation
          };
          if (
            this.messageItem1.studyingStartDate >
            this.messageItem1.studyingEndDate
          ) {
            this.$Message.error("开始日期不得大于毕业日期");
            return;
          }

          if (this.type == 1) {
            this.data1.forEach(item => {
              if (
                item.whetherHighestEducation == "1" &&
                this.obj1.whetherHighestEducation == "1"
              ) {
                this.repeat = 1;
              }
            });
          } else if (this.type == 2) {
            this.data1.forEach((item, index) => {
              if (
                item.whetherHighestEducation == "1" &&
                this.obj1.whetherHighestEducation == "1" &&
                index !== this.index
              ) {
                this.repeat = 1;
              }
            });
          }
          if (this.repeat == 1) {
            this.$Message.error("只能填写一条最高学历的数据!");
            // this.showInformation1 = false
            this.repeat = 0;
            return;
          } else {
            if (this.type == 1) {
              this.data1.push(this.obj1);
            } else if (this.type == 2) {
              this.data1.splice(this.index, 1, this.obj1);
            }
          }
          this.showInformation1 = false;
          this.index = null;
          this.type = null;
        } else {
          this.$Message.error("请填写教育背景信息");
        }
      });
    },
    addItem2() {
      if (this.disabledVal == false) {
        this.messageItem2 = {};
        this.showInformation2 = true;
        this.type = 1;
        this.titleText = "新增";
      }
    },
    editItem2(row, index) {
      if (this.disabledVal == false) {
        this.showInformation2 = true;
        this.type = 2;
        this.index = index;
        this.titleText = "编辑";
        this.messageItem2.workingStartDate = row.workingStartDate;
        this.messageItem2.workingEndDate = row.workingEndDate;
        this.messageItem2.workingName = row.workingName;
        this.messageItem2.position = row.position;
        this.messageItem2.majorDuties = row.majorDuties;
        this.messageItem2.reasonLeave = row.reasonLeave;
      }
    },
    deleteItem2(row, index) {
      if (this.disabledVal == false) {
        this.data2.splice(index, 1);
      }
    },
    confirmData2() {
      this.$refs["messageItem2"].validate(valid => {
        if (valid) {
          this.obj2 = {
            workingStartDate: this.messageItem2.workingStartDate,
            workingEndDate: this.messageItem2.workingEndDate,
            workingName: this.messageItem2.workingName,
            position: this.messageItem2.position,
            majorDuties: this.messageItem2.majorDuties,
            reasonLeave: this.messageItem2.reasonLeave
          };
          if (
            this.messageItem2.workingStartDate >
            this.messageItem2.workingEndDate
          ) {
            this.$Message.error("开始日期不得大于结束日期");
            return;
          }
          if (this.type == 1) {
            this.data2.push(this.obj2);
          } else if ((this.type = 2)) {
            this.data2.splice(this.index, 1, this.obj2);
          }
          this.showInformation2 = false;
          this.index = null;
          this.type = null;
        } else {
          this.$Message.error("请填写工作经验信息");
        }
      });
    },
    addItem3() {
      if (this.disabledVal == false) {
        this.messageItem3 = {};
        this.showInformation3 = true;
        this.type = 1;
        this.titleText = "新增";
      }
    },
    editItem3(row, index) {
      if (this.disabledVal == false) {
        this.showInformation3 = true;
        this.type = 2;
        this.index = index;
        this.titleText = "编辑";
        this.messageItem3.userName = row.userName;
        this.messageItem3.relationship = row.relationship;
        this.messageItem3.mobilePersonal = row.mobilePersonal;
        this.messageItem3.emergencyContact = row.emergencyContact;
      }
    },
    deleteItem3(row, index) {
      if (this.disabledVal == false) {
        this.data3.splice(index, 1);
      }
    },
    confirmData3() {
      this.$refs["messageItem3"].validate(valid => {
        if (valid) {
          this.obj3 = {
            userName: this.messageItem3.userName,
            relationship: this.messageItem3.relationship,
            mobilePersonal: this.messageItem3.mobilePersonal,
            emergencyContact: this.messageItem3.emergencyContact
          };
          if (this.type == 1) {
            this.data3.push(this.obj3);
          } else if ((this.type = 2)) {
            this.data3.splice(this.index, 1, this.obj3);
          }
          this.showInformation3 = false;
          this.index = null;
          this.type = null;
        } else {
          this.$Message.error("请填写工作经验信息");
        }
      });
    },
    submit() {
      if (this.data1.length == 0) {
        this.$Message.error("请在教育履历中填写一条教育信息!");
        return;
      }
      if (this.data3.length == 0) {
        this.$Message.error("请在社会关系中填写一条紧急联系人信息!");
        return;
      }
      this.data1.forEach(item => {
        item.studyingStartDate =
          item.studyingStartDate == ""
            ? ""
            : this.date.dateVal(item.studyingStartDate, "YYYY-MM-DD");
        item.studyingEndDate =
          item.studyingEndDate == ""
            ? ""
            : this.date.dateVal(item.studyingEndDate, "YYYY-MM-DD");
      });
      this.data2.forEach(item => {
        item.workingStartDate =
          item.workingStartDate == ""
            ? ""
            : this.date.dateVal(item.workingStartDate, "YYYY-MM-DD");
        item.workingEndDate =
          item.workingEndDate == ""
            ? ""
            : this.date.dateVal(item.workingEndDate, "YYYY-MM-DD");
      });
      this.formItem.applicantDate =
        this.formItem.applicantDate == ""
          ? ""
          : this.date.dateVal(this.formItem.applicantDate, "YYYY-MM-DD");

      this.$refs["formItem"].validate(valid => {
        if (valid) {
          this.$Modal.confirm({
            title: this.$notice("submission"),
            content: "",
            onOk: () => {
              let obj = {
                ...this.formItem,
                applyOnboardingEducations: this.data1,
                applyOnboardingWorks: this.data2,
                applyOnboardingSocials: this.data3
              };
              this.loading = true;
              axios
                .post("OnboardingApplication/InsertOnboardingApplication", obj)
                .then(res => {
                  this.loading = false;
                  if (res) {
                    this.$Message.success("入职信息提交成功！");
                  }
                });
            },
            onCancel: () => {}
          });
        } else {
          this.$Message.error("请正确填写申请信息！");
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    returnPages() {
      this.$router.push("/EAA45DE9B245E28679E5CD284DC960BC/A3FFBEBFDB713E27");
    }
  }
};
</script>

<style scoped>
.groupDisplay {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.elementDisplay {
  width: calc((100% - 210px) / 3);
  float: left;
}
.RowDisplay {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.ColDisplay {
  width: calc((100% - 140px) / 2);
  float: left;
}
@media screen and (max-width: 1190px) and (min-width: 965px) {
  .groupDisplay {
    width: 100%;
  }
  .elementDisplay {
    width: calc((100% - 50px) / 2);
    float: left;
  }
  .RowDisplay {
    width: 100%;
  }
  .ColDisplay {
    width: calc((100% - 20px) / 2);
    float: left;
  }
}
@media screen and (max-width: 965px) and (min-width: 820px) {
  .groupDisplay {
    width: 100%;
  }
  .elementDisplay {
    width: calc((100% - 30px) / 2);
    float: left;
  }
  .RowDisplay {
    width: 100%;
  }
  .ColDisplay {
    width: 100%;
    float: left;
  }
}
@media screen and (max-width: 820px) {
  .groupDisplay {
    width: 100%;
  }
  .elementDisplay {
    width: 100%;
    float: left;
  }
  .RowDisplay {
    width: 100%;
  }
  .ColDisplay {
    width: 100%;
    float: left;
  }
}
.liStyle {
  margin-left: 15px;
}
.NewInformation {
  border: 1px solid #dcdee2;
  border-top: white;
  margin-bottom: 30px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  color: #6d6d6d;
  transition: 0.3s;
}
.NewInformation:hover {
  color: black;
  box-shadow: 0px 2px 10px rgb(192, 191, 191);
}
.NewInformation_title {
  text-align: center;
}
.btnGroup {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.btnStyle {
  width: 140px;
  margin: 0 15px 30px 15px;
}
@media screen and (max-width: 760px) {
  .btnGroup {
    display: flex;
    flex-wrap: wrap;
  }
  .btnStyle {
    width: 140px;
    margin: 0 10px 30px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyManagement/JobApplicationForm.vue